/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_KickerInputs */

const en_gc_home_kicker = /** @type {(inputs: Gc_Home_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spreadsheets, with an open mind.`)
};

const zh_gc_home_kicker = /** @type {(inputs: Gc_Home_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用开放的思路，重新认识电子表格。`)
};

/**
* | output |
* | --- |
* | "Spreadsheets, with an open mind." |
*
* @param {Gc_Home_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_kicker = /** @type {((inputs?: Gc_Home_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_kicker(inputs)
	return zh_gc_home_kicker(inputs)
});
export { gc_home_kicker as "gc.home.kicker" }